import type { RouteRecordRaw } from "vue-router";
import { Module } from "@/modules/tenantWebsite/enums";

export default <RouteRecordRaw[]>[
  {
    path: "/home",
    meta: {
      module: Module.Home,
    },
    children: [
      {
        path: "",
        name: "home.show",
        component: () =>
          import("@/modules/tenantWebsite/home/views/HomeView.vue"),
        children: [
          {
            path: "/boeken",
            name: "home.appointment.tool",
            component: () =>
              import("@/modules/tenantWebsite/appointment/views/AppointmentToolView.vue"),
          },
        ],
      },
    ],
  },
];
